import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobTypeSwitcherComponent } from './job-type-switcher.component';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [JobTypeSwitcherComponent],
    imports: [
        CommonModule,
        MaterialModule
    ],
    exports: [JobTypeSwitcherComponent],
})
export class JobTypeSwitcherModule { }